




















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import MembershipCategoriesList from '@subscriptions/components/lists/admin/membership-categories-list.vue';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import moment from 'moment';

@Component({
  name: 'bpc-membership-categories',
  components: {
    'bpc-membership-categories-list': MembershipCategoriesList,
    'bpc-content-wrapper': ContentWrapper,
  },
})
export default class MembershipCategories extends Vue {
  // PROPS
  // DATA
  timestamp = moment().unix();
  // public formModel: MembershipCategory = null;
  // LIFECYCLE
  // created(){}
  // mounted(){}
  // updated(){}
  // destroyed(){}
  // COMPUTED
  get actionsPortalTarget() {
    return `membership-categories-actions-${this.timestamp}`;
  }
  // METHODS
  // WATCHERS
}
